import React from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import CustomLink from '@shared/components/customLink'
import { articleLoader } from '@shared/libs/allLoader'
import LazyLoad from '@shared/components/lazyLoad'
import { RightArrow } from '@shared/components/ctIcons'
import NoData from '@shared/components/noData'

const TeamInfo = dynamic(() => import('@shared/components/team/teamInfo'))
const ArticleSearch = dynamic(() => import('@shared/components/article/articleSearch'), { loading: () => articleLoader(['g']) })
const TeamScorecard = dynamic(() => import('@shared/components/team/teamScorecard'))
const TeamForm = dynamic(() => import('@shared/components/team/teamForm'))

const TeamOverview = ({ teamData, article, miniScorecard, teamFormInput }) => {
  const router = useRouter()

  return (
    <>
      {
        (teamData?.sContent || teamData?.oSocialMedia?.oFacebook?.sHandle || teamData?.oSocialMedia?.oInstagram?.sHandle || teamData?.oSocialMedia?.oWikipedia?.sHandle || teamData?.oSocialMedia?.oTwitter?.sHandle) &&
        (
          <Row className='pb-5'>
            <TeamInfo data={teamData} />
          </Row>
        )
      }
      {
        miniScorecard?.length > 0 &&
        (
          <TeamScorecard data={miniScorecard} teamData={teamData} />
        )
      }
      {
        teamFormInput?.length > 0 && (
          <TeamForm
            team={teamFormInput}
            teamData={teamData}
          />
        )
      }
      {
        teamFormInput?.length > 0 && article?.aResults?.length > 0 ? (
          <LazyLoad>
            <Row>
              <h3 className="small-head">
                Team News
              </h3>
              {article?.aResults?.map((a, i) => {
                return (
                  <React.Fragment key={i + a?._id}>
                    <Col lg={4} sm={6} id={a?._id}>
                      <ArticleSearch data={a} isVideo={a?.__typename === 'oVideoData'} />
                    </Col>
                  </React.Fragment>
                )
              })}
              <div className="text-center theme-text mb-3">
                <CustomLink href={`/${router.asPath}/news`} prefetch={false}>
                  <a className="theme-btn btn btn-primary">
                    More News
                    <RightArrow />
                  </a>
                </CustomLink>
              </div>
            </Row>
          </LazyLoad>
        ) : article?.aResults?.length > 0 ? (
          <Row>
            <h3 className="small-head">
              Team News
            </h3>
            {article?.aResults?.map((a, i) => {
              return (
                <React.Fragment key={i + a?._id}>
                  <Col lg={4} sm={6} id={a?._id}>
                    <ArticleSearch data={a} isVideo={a?.__typename === 'oVideoData'} />
                  </Col>
                </React.Fragment>
              )
            })}
            <div className="text-center theme-text mb-3">
              <CustomLink href={`/${router.asPath}/news`} prefetch={false}>
                <a className="theme-btn btn btn-primary">
                  More News
                  <RightArrow />
                </a>
              </CustomLink>
            </div>
          </Row>
        ) : <></> // TODO:Find best way to handle empty area
      }
      {
        (miniScorecard?.length < 0 && teamFormInput?.length < 0 && article?.aResults?.length < 0) && <NoData />
      }
    </>
  )
}

TeamOverview.propTypes = {
  teamData: PropTypes.object,
  article: PropTypes.object,
  miniScorecard: PropTypes.arrayOf(PropTypes.object),
  teamFormInput: PropTypes.arrayOf(PropTypes.object)
}

export default TeamOverview
